import Cookies from "./cookies";
import Page from "./page";
import User from "./user";
import UserAgent from "./user-agent";
export { debounce, getUserVisitorId, loadScript, throttle } from "./utils";
export { Cookies, Page, User, UserAgent };

const w = window as unknown as { BD: {
  Cookies  : typeof Cookies,
  User     : User,
  UserAgent: UserAgent
} }

w.BD = w.BD || {};
w.BD.Cookies = Cookies;
w.BD.UserAgent = UserAgent;